import { Image } from "./image";
import React from "react";

export const Gallery = (props) => {
  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Gallery</h2>
          <p>
            Explorez nos réalisations en images et découvrez comment nous transformons chaque démarche en succès :
            demandes d’asile, titres de séjour, naturalisation, nationalité française, visas, prolongation de visa,
            démarches administratives (état civil, mariage), contestation OQTF/IRTF, regroupement familial,
            droit du travail pour étrangers, assistance juridique (divorce, droit de garde, conflits, dettes),
            tutelle-tuteur et droit à la retraite..
          </p>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-sm-6 col-md-4 col-lg-4"
                  >
                    <Image
                      title={d.title}
                      largeImage={d.largeImage}
                      smallImage={d.smallImage}
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
  );
};
